var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon list",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.323 1.29a.773.773 0 0 1 .774.774v1.548a.772.772 0 0 1-.774.774H.774A.773.773 0 0 1 0 3.613V2.064a.774.774 0 0 1 .774-.774zm12.645.516a1.033 1.033 0 1 1 0 2.065h-9.29a1.033 1.033 0 0 1 0-2.065zm0 5.161a1.033 1.033 0 1 1 0 2.065h-9.29a1.033 1.033 0 0 1 0-2.065zm0 5.161a1.033 1.033 0 1 1 0 2.065h-9.29a1.033 1.033 0 0 1 0-2.065zM0 7.225a.773.773 0 0 1 .774-.774h1.548a.772.772 0 0 1 .774.774v1.548a.772.772 0 0 1-.774.774H.774A.773.773 0 0 1 0 8.774zm2.323 4.387a.772.772 0 0 1 .774.774v1.548a.772.772 0 0 1-.774.774H.774A.773.773 0 0 1 0 13.935V12.39a.773.773 0 0 1 .774-.774z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.d70423b49d009b824cfd2a03c5d72a02.svg";
export { ForwardRef as ReactComponent };